import React, { useEffect, useState } from "react";
import Modal from "react-awesome-modal";
import { Link } from "react-router-dom";
import useDelete from "../../Hooks/useDelete";
import useFetch from "../../Hooks/useFetch";
import useSave from "../../Hooks/useSave";
import useUpdate from "../../Hooks/useUpdate";
import useValidateRole from "../../Hooks/useValidateRole";
import Table from "./../../Components/Table";

const ProductStatus = (props) => {
    const [open, setOpen] = useState(false);
    const [inputs, setInputs] = useState({});
    const [view, setView] = useState(false);
    const [update, setUpdate] = useState(false);
    const [PageRole, setPageRole] = useState("Product Status");

    const url = "api/productStatus";
    const { state, FetchAll } = useFetch(url + "/getAll?page=0&size=10");

    useEffect(() => {
        FetchAll();
    }, []);

    const handleOpenModal = () => {
        setInputs({});
        setOpen(true);
    };

    const handleInputChange = (event) => {
        event.persist();
        const target = event.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        setInputs((inputs) => ({ ...inputs, [name]: value }));
    };

    const handleEdit = () => {
        if (inputs.id) {
            setOpen(true);
            setUpdate(true);
            setView(false);
        } else {
            alert("Select a record to edit");
        }
    };

    const handleView = () => {
        if (inputs.id) {
            setView(true);
            setUpdate(false);
            setOpen(true);
        } else {
            alert("Select a record to view");
        }
    };

    const handleSelect = (k) => {
        setInputs(k);
    };

    const handleCloseModal = () => {
        setInputs({});
        setOpen(false);
        setView(false);
        setUpdate(false);
    };

    const HandleSave = () => {
        useSave(url + "/create", inputs);
        FetchAll();
    };

    const HandleUpdate = () => {
        useUpdate(url + "/update?id=" + inputs.id, inputs);
        FetchAll();
    };

    const HandleSubmit = (event) => {
        event.preventDefault();
        if (update) {
            HandleUpdate();
        } else {
            HandleSave();
        }
    };

    const CallDeleteHook = () => {
        useDelete(url + "/delete?id=" + inputs.id);
        FetchAll();
    };

    const HandleDelete = () => {
        if (inputs.id) {
            CallDeleteHook();
        } else {
            alert("Select a record to delete");
        }
    };

    const formatDate = (timestamp) => {
        if (!timestamp) return "";
        const date = new Date(timestamp);
        return date.toISOString().slice(0, 16);
    };

    const ColumnData = [
        { label: "Name", field: "name", sort: "asc" },
        { label: "Description", field: "description", sort: "asc" },
    ];

    let RowData = [];
    const rows = state.data?.productStatus || [];

    if (rows.length > 0) {
        rows.forEach((k) => {
            const Rowdata = {
                clickEvent: () => handleSelect(k),
                name: k.name,
                description: k.description,
            };
            RowData.push(Rowdata);
        });
    }

    const ActionsBtn = () => {
        return (
            <div>
                {useValidateRole(PageRole, "Edit") ? (
                    <button
                        className="btn btn-primary p-2"
                        type="button"
                        onClick={handleEdit}
                    >
                        Update
                    </button>
                ) : null}
                &nbsp; &nbsp;
                {useValidateRole(PageRole, "Remove") ? (
                    <button onClick={HandleDelete} className="btn btn-danger p-2">
                        Delete
                    </button>
                ) : null}
                &nbsp;
                <button
                    className="btn btn-warning p-2"
                    type="button"
                    onClick={handleCloseModal}
                >
                    Close
                </button>
            </div>
        );
    };

    return (
        <div id="content" className="content">
            <ol className="breadcrumb float-xl-right">
                <li className="breadcrumb-item">
                    <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active">Product Status</li>
            </ol>
            <h1 className="page-header mb-3">Product Status</h1>
            <div style={{ backgroundColor: "white" }}>
                <div className="row">
                    <div className="col-sm-12 d-flex flex-row float-right">
                        &nbsp; &nbsp; &nbsp;
                        {useValidateRole(PageRole, "AddNew") ? (
                            <button
                                onClick={handleOpenModal}
                                className="btn btn-primary p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; New &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "View") ? (
                            <button
                                onClick={handleView}
                                className="btn btn-success p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; View &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Edit") ? (
                            <button
                                onClick={handleEdit}
                                className="btn btn-info p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Edit &nbsp;
                            </button>
                        ) : null}
                        {useValidateRole(PageRole, "Remove") ? (
                            <button
                                onClick={HandleDelete}
                                className="btn btn-danger p-2"
                                style={{ marginRight: 5, marginTop: 5 }}
                            >
                                &nbsp; Delete &nbsp;
                            </button>
                        ) : null}
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <Table Rows={RowData} columns={ColumnData} />
                    </div>
                </div>
            </div>

            <Modal visible={open} width="60%" height="50%" effect="fadeInUp">
                <div style={{ overflowY: "auto", height: "100%" }}>
                    <a className="close" onClick={() => handleCloseModal()}>
                        &times;
                    </a>

                    <div className="row">
                        <div className="col-sm-5"></div>
                        {view ? null : (
                            <div className="col-sm-4 font-weight-bold text-blue">
                                Product Status
                            </div>
                        )}
                    </div>
                    <div className="container-fluid">
                        <div className="col-sm-12">
                            <div className="ibox-content">
                                <br />

                                {view ? (
                                    <div>
                                        <h3>Product Status</h3>
                                        <table className="table table-sm">
                                            <tbody>
                                                <tr>
                                                    <td className="font-weight-bold">Name:</td>
                                                    <td>{inputs.name}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Description:</td>
                                                    <td>{inputs.description}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created At:</td>
                                                    <td>{inputs.createdAt ? formatDate(inputs.createdAt) : ""}</td>
                                                </tr>
                                                <tr>
                                                    <td className="font-weight-bold">Created By:</td>
                                                    <td>{inputs.createdBy}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <br />
                                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                                            <ActionsBtn />
                                        </div>
                                        <br />
                                    </div>
                                ) : (
                                    <form className="form-horizontal" onSubmit={HandleSubmit}>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="name" className="font-weight-bold">
                                                        Name
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="name"
                                                        required
                                                        value={inputs.name || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="description" className="font-weight-bold">
                                                        Description
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="description"
                                                        required
                                                        value={inputs.description || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="createdAt" className="font-weight-bold">
                                                        Created At
                                                    </label>
                                                    <input
                                                        type="datetime-local"
                                                        className="form-control"
                                                        name="createdAt"
                                                        required
                                                        value={inputs.createdAt ? formatDate(inputs.createdAt) : ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-sm">
                                                <div className="form-group">
                                                    <label htmlFor="createdBy" className="font-weight-bold">
                                                        Created By
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="createdBy"
                                                        required
                                                        value={inputs.createdBy || ""}
                                                        onChange={handleInputChange}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "flex-end",
                                            }}
                                        >
                                            <div className="d-flex flex-row">
                                                {update ? (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Update
                                                    </button>
                                                ) : (
                                                    <button className="btn btn-primary p-2" type="submit">
                                                        Submit
                                                    </button>
                                                )}
                                                &nbsp;
                                                <button
                                                    className="btn btn-warning p-2"
                                                    type="button"
                                                    onClick={handleCloseModal}
                                                >
                                                    Close
                                                </button>
                                            </div>
                                            <br />
                                        </div>
                                    </form>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};

export default ProductStatus;
